
export const carrieBio = {
  _id: 'carrieBioId',
  userId: 'carrieUserId',
  email: 'carrie@email.com',
  aboutMe: [
    `New Yorker into shoes, restaurants, and melodrama`,
    `The girl you locked eyes with at the cafe but never talked to`,
    `Sex columnist, looking for material for her next article`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `Someone who looks good in a suit`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Sundays in the park, going to a gallery and forgetting to look at the art, and when curtains match the bedsheets`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Stripes or plaid?`,
    }
  ],
  hobbies: [
    `Fashion`,
    `Design`,
    `Restaurants`,
    `Coffee`,
    `Writing`
  ],
  vitalInfo: {
    firstName: `Carrie`, 
    age: 32,
    gender: `Female`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 62,
    heightCM: 157,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Connecticut`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: `Brown University`,
    profession: `Sex Columnist`,
    employer: `The New York Star`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Yes`,
    cigarettes: `Yes`,
    weed: `Sometimes`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const aidenBio = {
  _id: 'aidenBioId',
  userId: 'aidenUserId',
  email: 'aiden@email.com',
  aboutMe: [
    `Furniture maker and dog dad living in New York`,
    `Furniture maker and dog dad living in New York`,
    `Furniture maker and dog dad living in New York`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `My dog Pete, he's always chasing a new squirrel`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Weekends at my cabin in the Catskills`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Mountains or beach?`,
    }
  ],
  hobbies: [
    `Woodworking`,
    `Bars/Restaurants`,
    `Camping`,
    `Weekend Getaways`,
    `Farmer's Markets`
  ],
  vitalInfo: {
    firstName: `Aiden`, 
    age: 34,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 74,
    heightCM: 188,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Virginia`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: `Design School`,
    profession: `Furniture Maker`,
    employer: `Myself`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Dog'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const alexanderBio = {
  _id: 'alexanderBioId',
  userId: 'alexanderUserId',
  email: 'alexander@email.com',
  aboutMe: [
    `Russian visual artist exhibiting in Paris and New York`,
    `Russian visual artist exhibiting in Paris and New York`,
    `Russian visual artist exhibiting in Paris and New York`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `Someone chic with a good sense of humor`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Visiting 24-hour art exhibits at 3am to make sure they're not cheating the 24 hours`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Paris or New York?`,
    }
  ],
  hobbies: [
    `Art`,
    `Restaurants`,
    `Hotels`,
    `Cooking`,
    `Soirées`
  ],
  vitalInfo: {
    firstName: `Alexander`, 
    age: 58,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 68,
    heightCM: 173,
    inOrCmPreference: 'cm',
    currentCity: `NYC`,
    hometown: `Moscow`,
    languages: [`English`, `Russian`, `French`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: ``,
    university: ``,
    profession: `Visual Artist`,
    employer: `Myself`,
    children: `Have children`,
    familyPlans: `Don't want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Yes`,
    cigarettes: `Sometimes`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const burgerBio = {
  _id: 'burgerBioId',
  userId: 'burgerUserId',
  email: 'burger@email.com',
  aboutMe: [
    `Fiction writer living in New York`,
    `Fiction writer living in New York`,
    `Fiction writer living in New York`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `A new book publisher`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Burgers, obviously`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Are motorcycles cool if you don't know how to drive them?`,
    }
  ],
  hobbies: [
    `Writing`,
    `Bars/Restaurants`,
    `Travel`,
    `Running`,
    `Cinema`
  ],
  vitalInfo: {
    firstName: `Burger`, 
    age: 32,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 71,
    heightCM: 180,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Connecticut`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: `Columbia`,
    profession: `Fiction Writer`,
    employer: ``,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const mrBigBio = {
  _id: 'mrBigBioId',
  userId: 'mrBigUserId',
  email: 'mrbig@email.com',
  aboutMe: [
    `Investor in New York who enjoys cigars, Chinese food, and fine wine`,
    `Investor in New York who enjoys cigars, Chinese food, and fine wine`,
    `Investor in New York who enjoys cigars, Chinese food, and fine wine`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `Someone to laugh with`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Riding in the back seat as my chauffeur drives through the New York streets without a destination in mind`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Red tie or blue tie?`,
    }
  ],
  hobbies: [
    `Parties`,
    `Bars/Restaurants`,
    `Basketball`,
    `Wine`,
    `Cigars`
  ],
  vitalInfo: {
    firstName: `Mr Big`, 
    age: 44,
    gender: `Male`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Women`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 73,
    heightCM: 185,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `NYC`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Postgrad`,
    university: `Harvard`,
    profession: `Investor`,
    employer: ``,
    children: `Don't have children`,
    familyPlans: `Prefer not to say`,
    datingIntentions: `Prefer not to say`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Yes`,
    cigarettes: `Sometimes`,
    weed: `Sometimes`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}